import withRoot from './modules/withRoot';
// --- Post bootstrap -----
import React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Markdown from './modules/components/Markdown';
import Typography from './modules/components/Typography';
import AppAppBar from './modules/views/AppAppBar';
import terms from './modules/views/terms.md';
import AppFooter from './modules/views/AppFooter';

function DashobHome() {
  return (
    <React.Fragment>
      <Container>
        <div mt={7} mb={12}>
          <h3>
              Activation Code: nf4f87b4fnh4fn9
          </h3>
          <h6>
              Paste the activation code inside Dashob Software
          </h6>



        </div>
      </Container>
    </React.Fragment>
  );
}

export default withRoot(DashobHome);
